<template lang="pug">
  div
    Section1Widget(to="/")
    b-spinner(v-if="!top_categories" variant="secondary")
    CategoryInfo(:key="c.id" v-for="c in top_categories" :category="c" )
</template>
<script>
import Section1Widget from './components/Section1Widget.vue'
import CategoryInfo from './components/CategoryInfo.vue'
export default {
  name: 'Products',
  components: {
    Section1Widget,
    CategoryInfo,
  },
  data: function(){
    return {
    }
  },
  computed: {
    top_categories: function(){
      if(!this.$root.categories) return [];
      return this.$root.categories.reduce((agg,cat)=>{
        if(!cat.parent_id) agg.push(cat);
        return agg;
      }, []);
    }
  }
}
</script>
